import * as _ from 'lodash';
import { CONFIG } from '../config/config';

export const QUERY_KEYS = {
  NOTIFICATIONS: 'NOTIFICATIONS',
  SUGGESTIONS: 'SUGGESTIONS',
  USERS: 'USERS',
  TEAM: 'TEAM',
  USERS_ALL: 'USERS_ALL',
  FOLLOWERS: 'FOLLOWERS',
  FOLLOWINGS: 'FOLLOWINGS',
  BLOCKED: 'BLOCKED',
  INACTIVE: 'INACTIVE',
  USER: 'USER',
  USER_POSTS: 'USER_POSTS',
  USER_SAVED: 'USER_SAVED',
  POSTS: 'POSTS',
  POST: 'POST',
  LIKES: 'LIKES',
  COMMENTS: 'COMMENTS',
  CHATS: 'CHATS',
  MESSAGES: 'MESSAGES',
  CHATS_USERS: 'CHATS_USERS',
  GROUP: 'GROUP',
  GROUPS: 'GROUPS',
  GROUPS_POSTS: 'GROUPS_POSTS',
  GROUPS_USERS: 'GROUPS_USERS',
  GROUPS_SUGGESTIONS: 'GROUPS_SUGGESTIONS',
  TASKS: 'TASKS',
  PROJECTS: 'PROJECTS',
  PROJECT_TAGS: 'PROJECT_TAGS',
  PROJECT_USERS: 'PROJECT_USERS',
  ASSETS: 'ASSETS',
  ASSETS_TAGS: 'ASSETS_TAGS',
  PAGES: 'PAGES',
  PAGES_VIEW: 'PAGES_VIEW',
  BUSINESSES: 'BUSINESSES',
  CLIENTS: 'CLIENTS',
  CLIENTS_ALL: 'CLIENTS_ALL',
  QUOTATIONS: 'QUOTATIONS',
  QUOTATIONS_ALL: 'QUOTATIONS_ALL',
  DOCUMENTS: 'DOCUMENTS',
  LEAVES: 'LEAVES',
  FORMS: 'FORMS',
  FORMS_TAGS: 'FORMS_TAGS',
  FORMS_DATA: 'FORMS_DATA'
};

export const formatQueryData = (data: any) => {
  return data?.data ? (_.isArray(data?.data) ? [...data.data] : { ...data.data }) : undefined;
};

export const formatInfiniteQueryData = (data: any) => {
  return (data && (data.pages?.map((g: any) => (g.data && g.data.map((data: any) => data || [])) || []) || []).flat()) || [];
};

export const getNextPageParam = (lastPage: any, pages: any, isLarge: boolean) => {
  const pageLimit = isLarge ? CONFIG.PAGE_LIMIT_LARGE : CONFIG.PAGE_LIMIT;
  if (lastPage?.data?.length === pageLimit) {
    return pages.length + 1;
  }
  return undefined;
};

export const onErrorData = (queryClient: any, queryKey: any, context: any) => {
  queryClient.setQueryData(queryKey, context?.oldData);
};
